import  { useState, useEffect } from 'react'
import  { useSWRConfig } from 'swr'
import { useNavigate } from 'react-router-dom'
import { apiNlpSimilarity } from '../../api'

const fetcher = async (st1, st2) => {
            
               
  if (st1 && st2 ) {
     try{
      const data = await apiNlpSimilarity(st1, st2);
      return { data, status: 200 };
}

    catch (error) {
      return error
    }

   


}}

function getUniqueWords(str) {
  const wordsArray = str.split(/\s+/);
  const uniqueWords = new Set(wordsArray);
  return uniqueWords;
}
const PythonSc =  ({st1, st2}) => {

  const { mutate } = useSWRConfig();
  const navigate = useNavigate();
    
    const [similarity, setSimilarity] = useState(null);
    const [trigger, setTrigger] = useState(null);
    const [response, setResponse] = useState(null);
    const [afterfetch, setAfterfetch] = useState(false);
    const [refreshCount, setRefreshCount] = useState(0);

    useEffect(() => {
      const storedCount = localStorage.getItem('refreshCount');
      if (storedCount) {
        setRefreshCount(Number(storedCount));
      }
    }, []);
   
    console.log(refreshCount)

    useEffect(() => {
      localStorage.setItem('refreshCount', refreshCount.toString());
      if (refreshCount >= 3) {
        // Display alert and navigate somewhere after 3 refreshes
        alert('Πρόβλημα επικοινωνίας με τον server. Παρακαλώ δοκιμάστε αργότερα!');
        navigate('/'); }
    }, [refreshCount, navigate]);

    useEffect(() => {
        if(trigger === null){
            setTrigger(true);
        }
    }, []);

    
 
          

          useEffect(() => {
            if(trigger === true){
              let set1 = getUniqueWords(st1)
              let set2 = getUniqueWords(st2)

              st1 = [...set1].join(' ')
              st2 = [...set2].join(' ')
            
            mutate("similarity",fetcher(st1, st2)
              .then(({data,status}) => {
                setResponse(status)
                setAfterfetch(true)
                data?setSimilarity(data.similarity):setSimilarity(null)
              },{
                revalidateOnFocus: false,
                revalidateOnReconnect: false,
                revalidateIfStale: true,
              
              
                 }))}}
              

             
          , [ trigger, st1, st2,fetcher]);

          useEffect(() => {
            if (isNaN(similarity)) {
              mutate("similarity");
            }
          }, [similarity,trigger]);


          
     
      console.log("python:",similarity)
      

   if(afterfetch===true && response!== 200){
    window.location.reload();
    setRefreshCount(count => count + 1);
   }else if(afterfetch===true && response=== 200){
    localStorage.setItem('refreshCount', (0).toString());

   }
    
    return(
      similarity === null ? NaN :   similarity
    )
    
}


PythonSc.defaultProps = {
    st1: null,
    st2: null
}

export default PythonSc